import EntityFormComponent, {
  EntityFormComponentProps,
  EntityFormViewProps,
} from './EntityFormComponent';

export default EntityFormComponent;

export type { EntityFormComponentProps, EntityFormViewProps };
